<template>
  <Popup :title="title" @approve="handleApprove">
    <div class="forms">
      <div class="form-field">
        <FormFile
          v-model="value.file"
          hint="Формат: CSV (qr_url;hex8b;dec3b;fac_code), макс. 10 МБ"
        />
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from '../../components/Popup.vue'
import FormFile from '../../components/Form/File.vue'

export default {
  name: 'BlePassUpload',
  components: { Popup, FormFile },
  emits: ['approveBlePass', 'update:modelValue'],
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        file: null,
      }),
    },
  },
  methods: {
    validate() {
      const data = this.value

      if (!data.file) {
        this.$store.dispatch('setNotification', {
          text: 'Пожалуйста, выберите файл',
          type: 'cross-outlined',
        })
        return false
      }

      // Проверка типа файла (CSV)
      if (data.file && !data.file.name.toLowerCase().endsWith('.csv')) {
        this.$store.dispatch('setNotification', {
          text: 'Допустимый формат файла: CSV',
          type: 'cross-outlined',
        })
        return false
      }

      // Проверка размера файла (макс 10 МБ)
      const maxSize = 10 * 1024 * 1024 // 10 МБ в байтах
      if (data.file && data.file.size > maxSize) {
        this.$store.dispatch('setNotification', {
          text: 'Размер файла не должен превышать 10 МБ',
          type: 'cross-outlined',
        })
        return false
      }

      return true
    },

    handleApprove() {
      if (this.validate()) {
        this.$emit('approveBlePass', this.value)
      } else {
        throw new Error('Validation failed')
      }
    },
  },
  computed: {
    title() {
      return 'Добавить BLE пропуска через файл'
    },

    value: {
      get() {
        return this.modelValue
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.forms {
  display: flex;
  flex-direction: column;
  gap: $space-lg;
  width: 100%;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: $space-xxs;
}
</style>
